
export const storeSchema = {
  name: 'Store Schema',
  type: 'object',
  properties: {
    Name: {
      type: 'string',
      maxLength: 70,
      required: true,
    },
    DomainValidation: {
      type: 'string',
    },
    DestinationUrl: {
      type: 'string',
      maxLength: 128,
      required: true,
    },
    Description: {
      type: 'string',
      maxLength: 350,
      required: false,
    },
    UseSslCheckout: {
      type: 'boolean',
    },
    BlockAggregators: {
      type: 'boolean',
    },
    // ContactName: {
    //   type: 'string',
    //   maxLength: 128,
    // },
    EmailString: {
      type: 'string',
      maxLength: 128,
    },
    Market: {
      type: 'string',
    },
    RecieveUpdates: {
      type: 'boolean',
    },
  },
};

